import React from "react";
import { useAuth } from "../../context/UserContext";

import { MdDashboard, MdShoppingBag, MdInventory2 } from "react-icons/md";
import { IoPeopleSharp } from "react-icons/io5";
import { FaStoreAlt } from "react-icons/fa";
import { IoPersonCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { HiReceiptRefund } from "react-icons/hi";

function DashSidebar({ tab, changeTab }) {
    const navigate = useNavigate()
    const { user } = useAuth();

    const linkClasses = (index) =>
        index === tab
            ? "flex items-center px-6 py-3 text-white bg-primary rounded-md w-full"
            : "flex items-center px-6 py-3 text-gray-600 hover:bg-gray-100 hover:text-gray-800 transition-colors duration-200 rounded-md w-full";

    return (
        <div className="w-full md:w-64 lg:w-72 flex-shrink-0 ">
            <div className="bg-white p-6 rounded-lg shadow-md border sticky top-16">
                <nav className="space-y-2">
                    <button onClick={() => navigate('/auth/profile')} className="flex items-center px-6 py-3 text-gray-600 hover:bg-gray-100 hover:text-gray-800 transition-colors duration-200 rounded-md w-full">
                        <IoPersonCircleOutline size={24} />
                        <span className="ml-4 font-medium">Profile</span>
                    </button>
                    <button onClick={() => changeTab(0)} className={linkClasses(0)}>
                        <MdDashboard size={22} />
                        <span className="ml-4 font-medium">Dashboard</span>
                    </button>

                    {user?.is_admin && !user?.is_vendor && (
                        <>
                            <button onClick={() => changeTab(1)} className={linkClasses(1)}>
                                <IoPeopleSharp size={22} />
                                <span className="ml-4 font-medium">Users</span>
                            </button>
                            <button onClick={() => changeTab(4)} className={linkClasses(4)}>
                                <FaStoreAlt size={22} />
                                <span className="ml-4 font-medium">Stores</span>
                            </button>
                        </>
                    )}

                    <button onClick={() => changeTab(3)} className={linkClasses(3)}>
                        <MdInventory2 size={22} />
                        <span className="ml-4 font-medium">Products</span>
                    </button>

                    <button onClick={() => changeTab(2)} className={linkClasses(2)}>
                        <MdShoppingBag size={22} />
                        <span className="ml-4 font-medium">Orders</span>
                    </button>
                    <button onClick={() => changeTab(5)} className={linkClasses(5)}>
                        <HiReceiptRefund size={22} />
                        <span className="ml-4 font-medium">Refunds</span>
                    </button>
                </nav>
            </div>
        </div>
    );
}

export default DashSidebar;
